import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Loading } from '../components/common/Loading'

export const OAuthCallback = () => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const code = searchParams.get('code')
    const error = searchParams.get('error')

    if (error) {
      window.opener?.postMessage({ type: 'google-auth-error', error }, window.location.origin)
      window.close()
      return
    }

    if (code && window.opener) {
      window.opener.postMessage({ type: 'google-auth-code', code }, window.location.origin)
    }

    window.close()
  }, [searchParams])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <Loading size="lg" />
    </div>
  )
}
